module.exports = "/_next/static/files/5ccf07ad43035a2bd2adb9e2ee96fee2.png";